import {
  Checkbox,
  Description as UIDescription,
  Flex,
  H3,
  Link,
  Message as UIMessage,
  RadioGroup,
  Switch,
  TreeContainer,
} from "@evergis/ui";
import styled from "styled-components";
import { CopyTaskMessageContainer } from "../CopyResource/components/Layer/styled";

import { AttributesBlockContainer, DialogContent, RestrictedWidthContainer } from "../DialogComponents/styled";

export const TitleText = styled(H3)`
  margin: 0;
`;

export const SpatialContentContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;
  background-color: ${({ theme: { palette } }) => palette.element};
  padding-top: 4rem;
  padding-bottom: 4rem;
  align-items: center;
`;

export const SpatialReferenceDropdownContainer = styled(Flex)`
  > * + * {
    margin-left: 1rem;
  }
`;

export const AttributeCheckbox = styled(Checkbox)`
  > &::-webkit-scrollbar {
    background: green;
  }
`;

export const LoadFileContainer = styled(Flex)`
  flex-wrap: nowrap;
  margin-bottom: 0.625rem;
`;

export const LoadFileDescription = styled(UIDescription)`
  margin: 0 0 1rem 0;
`;

export const ImportSuccessContainer = styled(CopyTaskMessageContainer).attrs({ success: true })`
  margin-top: 4rem;
`;

export const ImportErrorsContainer = styled(Flex)`
  margin-top: 1rem;
`;

export const ProgressBlockContainer = styled(Flex)`
  flex-wrap: nowrap;
`;

export const ProgressTitle = styled.p`
  &&& {
    margin: 0 0 0.5rem;
  }
`;

export const LinearProgressContainer = styled(Flex)`
  width: 100%;
  height: 9.5625rem;
  padding-top: 4rem;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-shrink: 0;
`;

export const DownloadErrorLogLink = styled(Link)`
  display: flex;
  font: ${({ theme: { fonts } }) => fonts.description};
`;

export const Message = styled(UIMessage)`
  width: calc(100% - 2.125rem);
  margin: auto 0 1rem;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
`;

export const InfoMessage = styled(UIMessage)`
  display: flex;
  margin-right: auto;
  width: calc(100% - 2.125rem);
  font-size: 0.75rem;
  max-width: 25.75rem;
`;

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.5rem;
`;

export const MessageTitle = styled.div`
  font-size: 1rem;
`;

export const AttributesContainer = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CoordinatesInputTypesSwitch = styled(Switch)`
  margin-top: 1.5rem;
  margin-left: 1rem;
`;

export const Descr = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary} !important;
`;

export const ImportDescription = styled(Descr)`
  margin-bottom: 2rem;
  color: ${({ theme: { palette } }) => palette.textSecondary};

  abbr:not(:last-child):after {
    content: ", ";
  }

  strong {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
  }
`;

export const ImportDialogContent = styled(DialogContent)`
  padding-top: 0;

  ${AttributesBlockContainer} {
    margin-top: 0;

    ${RestrictedWidthContainer} {
      padding: 2rem 0 0.5rem 0.75rem;

      ${TreeContainer} {
        margin-top: 0.75rem;
      }
    }
  }
`;

export const ImportMetaPreview = styled(Flex)`
  align-items: center;

  img {
    margin-right: 1.5rem;
  }
`;

export const ImportTargetRadioGroup = styled(RadioGroup)`
  margin-bottom: 2rem;
`;

export const ImportTitleButtons = styled.div`
  margin: 2rem 0 -1.5rem;
`;
